import { render } from "./TemperatureDashboard.vue?vue&type=template&id=6746346e&scoped=true"
import script from "./TemperatureDashboard.vue?vue&type=script&lang=js"
export * from "./TemperatureDashboard.vue?vue&type=script&lang=js"

import "./TemperatureDashboard.vue?vue&type=style&index=0&id=6746346e&scoped=true&lang=scss"

import exportComponent from "/home/scotty/git/beamy/monolith/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6746346e"]])

export default __exports__